import stencilReduxGlobalScript from '/builds/sydle/sydle-one-ui/node_modules/.pnpm/@stencil+redux@0.2.0_redux@4.2.1/node_modules/@stencil/redux/dist/collection/global/store.js';
import sydleOneComponentsGlobalScript from '/builds/sydle/sydle-one-ui/packages/sydle-one-components/src/global/index.ts';
export const globalScripts = () => {
  return Promise.all([
    sydleOneComponentsGlobalScript(),
    stencilReduxGlobalScript(),
  ]);
};
